import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MerchantUserDto, MerchantUsersService } from './merchant-users.service';

@Component({
  selector: 'app-merchant-users-index',
  templateUrl: './merchant-users-index.component.html',
  styleUrls: ['./merchant-users-index.component.sass'],
})
export class MerchantUsersIndexComponent implements OnInit {
  users: MerchantUserDto[] = [];
  loading = false;

  displayedColumns = ['name', 'email', 'phone', 'gender', 'actions'];

  constructor(
    private svc: MerchantUsersService,
    private router: Router,
    private dialog: MatDialog,
    private toast: ToastService,
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.svc.list().subscribe({
      next: (list) => { this.users = list; this.loading = false; },
      error: () => { this.toast.showError('Erro ao carregar usuários.'); this.loading = false; },
    });
  }

  openCreate(): void {
    this.router.navigate(['merchants', 'users', 'create']);
  }

  openEdit(user: MerchantUserDto): void {
    this.router.navigate(['merchants', 'users', 'edit', user.id]);
  }

  confirmDelete(user: MerchantUserDto): void {
    const ref = this.dialog.open(DialogConfirmComponent, {
      data: {
        title: 'Remover usuário',
        content: `Deseja remover o usuário ${user.firstName} ${user.lastName}?`,
        yesText: 'Remover',
        noText: 'Cancelar',
      },
    });
    ref.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.svc.remove(user.id!).subscribe({
          next: () => { this.toast.showSuccess('Usuário removido.'); this.load(); },
          error: () => this.toast.showError('Erro ao remover usuário.'),
        });
      }
    });
  }

  goBack(): void {
    this.router.navigate(['merchants', 'onMyAccount']);
  }
}
